<template>
  <div>
    <div class="mb-3 border-bottom">
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="inlineRadio2"
          value="crud"
          name="permission_type"
          v-model="type"
        />
        <label class="form-check-label" for="inlineRadio2">CRUD Permission</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="inlineRadio1"
          value="basic"
          name="permission_type"
          v-model="type"
        />
        <label class="form-check-label" for="inlineRadio1">Basic Permission</label>
      </div>
    </div>
    <div v-if="type=='basic'">
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label>Display Name</label>
            <input name="display_name" class="form-control" v-model="display_name" placeholder="Name to be displayed" />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label>Name</label>
            <input name="name" class="form-control" v-model="name" placeholder="machine_readable_name" />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label>Description</label>
            <input name="description" class="form-control" v-model="description" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label>Resource Name</label>
            <input name="resource" class="form-control" v-model="resource" placeholder="Name of the resource" />
          </div>
          <div class="form-group">
            <label>Select permissions for this resource:</label>
            <div class="form-check" v-for="(option,idx) in options" :key="idx">
              <label>
                <input class="form-check-input" name="crud[]" type="checkbox" v-model="selectedCrud" :value="option.value" id />
                {{ option.text }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <h5>Selected Permissions</h5>
          <div>
            <table class="table table-sm hoverable borderles">
              <thead>
                <tr>
                  <th>Display Name</th>
                  <th>Name</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody v-if="resource.length > 2">
                <tr v-for="(crud,idx) in selectedCrud" :key="idx">
                  <td>{{ crudName(crud) }}</td>
                  <td>{{ crudSlug(crud) }}</td>
                  <td>{{ crudDescription(crud) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import slugify from "slugify";
export default {
  data() {
    return {
      type: "crud",
      display_name: "",
      description: "",
      resource: "",
      selectedCrud: ["create", "read", "edit", "delete"],
      options: [
        { text: "Create", value: "create" },
        { text: "Read", value: "read" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" }
      ]
    };
  },
  computed: {
    name: {
      get: function() {
        return slugify(this.display_name, { lower: true });
      },
      set: function(newVal) {
        return newVal;
      }
    }
  },
  methods: {
    crudName: function(item) {
      console.log(item.charAt(0));
      return (
        item.charAt(0).toUpperCase() +
        item.slice(1) +
        " " +
        this.resource.charAt(0).toUpperCase() +
        this.resource.slice(1)
      );
    },
    crudSlug: function(item) {
      return item.toLowerCase() + "-" + slugify(this.resource,{ lower: true});
    },
    crudDescription: function(item) {
      return (
        "Allow user to " +
        item.toUpperCase() +
        " " +
        this.resource.charAt(0).toUpperCase() +
        this.resource.slice(1)
      );
    }
  }
};
</script>

<style>
</style>